import { getRecoil, getRecoilPromise, setRecoil } from "recoil-nexus";
import { enabledParentIdsState, overrideFNOLDataState, fnolInstanceIsDirty } from "atoms/fnolInstanceState.atom";
import { fnolQuestionSetState, fnolQuestionSetStructureState } from "atoms/fnolQuestionSetState.atom";
import { getFnolThirdPartyArrayState } from "atoms/fnolThirdPartyState.atom";
import { isNullOrEmpty, isNullOrLengthIsZero } from "shared/Helpers";
import * as fnolComponentConstants from "constants/FnolComponentConstants";
import store from "store/appStore";
import { updateFnolInstanceComponent } from "slices/fnolInstanceSlice";

const fnolInstanceMetaDataSelector = (state) => state.fnolInstanceMetaData.metaData;
const fnolInstanceSelector = (state) => state.fnolInstance.componentValues.byFieldMappingId;

export const getFnolInstanceMetaDataState = () => {
  return new Promise((resolve) => {
    resolve(fnolInstanceMetaDataSelector(store.getState()));
  });
};

export const getFnolInstanceState = () => {
  return new Promise((resolve) => {
    const fnolInstanceByFieldMappingId = fnolInstanceSelector(store.getState());
    const fnolValues = Object.values(fnolInstanceByFieldMappingId);
    let newFnolInstance = [...fnolValues];
    resolve(newFnolInstance);
  });
};

export const getFnolQuestionSetStructure = () => {
  return new Promise((resolve) => {
    let fnolQuestionSetStructure = getRecoil(fnolQuestionSetStructureState);
    resolve(fnolQuestionSetStructure);
  });
};

export const getFnolQuestionSet = () => {
  return new Promise((resolve) => {
    let fnolQuestionSet = getRecoil(fnolQuestionSetState);
    let fnol = [...fnolQuestionSet];
    resolve(fnol);
  });
};

export const getFnolInstanceWithThirdPartyState = () => {
  return new Promise((resolve) => {
    const fnolInstanceByFieldMappingId = fnolInstanceSelector(store.getState());
    const fnolValues = Object.values(fnolInstanceByFieldMappingId);
    let newFnolInstance = [...fnolValues];
    // If we have a third party, get the global state and save it in the fnolInstance
    getFnolQuestionSet().then(async (fnol) => {
      const component = fnol.find((c) => c.controlType === fnolComponentConstants.FNOLCOMPONENT_THIRDPARTYBLOCK);
      if (isNullOrEmpty(component)) {
        resolve(newFnolInstance);
      } else {
        const thirdPartiesData = await getFnolThirdPartyArrayState();
        if (isNullOrLengthIsZero(thirdPartiesData.thirdPartyArray)) {
          resolve(newFnolInstance);
        } else {
          store.dispatch(
            updateFnolInstanceComponent({
              fieldValue: thirdPartiesData.thirdPartyArray,
              props: component,
              dropdownId: null,
              autoPopulatedBy: thirdPartiesData.autoPopulatedBy,
            })
          );
          const fnolInstanceByFieldMappingId = fnolInstanceSelector(store.getState());
          const fnolValues = Object.values(fnolInstanceByFieldMappingId);
          const fnolWithThirdParty = [...fnolValues];
          resolve(fnolWithThirdParty);
        }
      }
    });
  });
};

export const getOverrideFNOLDataState = () => {
  const overrideFNOLDataResult = getRecoil(overrideFNOLDataState);
  return overrideFNOLDataResult;
};

export const getFNOLInstanceIsDirtyState = () => {
  const currentFNOLInstanceHasIsDirtyState = getRecoil(fnolInstanceIsDirty);
  return currentFNOLInstanceHasIsDirtyState;
};

export const getEnabledParentIdsState = () => {
  return new Promise((resolve) => {
    getRecoilPromise(enabledParentIdsState).then((enabledIds) => {
      let newEnabledIds = [...enabledIds];
      resolve(newEnabledIds);
    });
  });
};

export const updateFnolInstanceLogic = (
  oldFnolInstanceState,
  fieldValue,
  props,
  dropdownId = "",
  autoPopulatedBy = null
) => {
  const updatedFnolInstanceState = [...oldFnolInstanceState];

  const fieldRecord = {
    componentOrder: props.componentOrder,
    controlType: props.controlType,
    onScreenText: props.onScreenText,
    fieldMapping: props.fieldMapping || "[Unknown]",
    fieldMappingId: props.fieldMappingId,
    value: fieldValue,
    [fnolComponentConstants.AUTO_POPULATED_BY]: autoPopulatedBy,
  };

  if (dropdownId !== "") {
    const dropdownKey = {
      dropdownId: dropdownId,
    };
    Object.assign(fieldRecord, dropdownKey);
  }

  if (!isNullOrEmpty(props.showMap)) {
    const showMap = {
      showMap: props.showMap,
    };
    Object.assign(fieldRecord, showMap);
  }

  const index = updatedFnolInstanceState.findIndex((c) => c.fieldMappingId === props.fieldMappingId);

  if (index !== -1) {
    updatedFnolInstanceState[index] = { ...updatedFnolInstanceState[index], ...fieldRecord };
  } else {
    updatedFnolInstanceState.push(fieldRecord);
  }

  return updatedFnolInstanceState;
};

export const updateOverrideFNOLDataState = (overrideFNOL) => {
  setRecoil(overrideFNOLDataState, (oldOverrideFNOLDataState) => {
    return overrideFNOL;
  });
};

export const updateFNOLInstanceIsDirtyState = (isDirty) => {
  setRecoil(fnolInstanceIsDirty, (oldFnolInstanceIsDirty) => {
    return isDirty;
  });
};

export const pushParentKeyToParentControlArrayState = (parentComponentKey) => {
  setRecoil(enabledParentIdsState, (oldEnabledParentIdsState) => [...oldEnabledParentIdsState, parentComponentKey]);
};
